import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from '../iconic/iconic.module';
import { ButtonComponent } from './button.component';

@NgModule({
  imports: [CommonModule, IconicModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent],
})
export class ButtonModule {}
